// extracted by mini-css-extract-plugin
export default {"auth_container":"M1FZ3o"};